import types from '../actions/types';

const initialState = {
  productCode: 0,
  quoter: '',

  departments: [],
  cities: [],
  streets: null, 
  occupations: [],

  genders: [
    {value: 'M', label: 'Masculino'}, 
    {value: 'F', label: 'Femenino'}, 
    {value: 'O', label: 'Otro'}
  ],

  documentTypes: [
    {value: '1', label: 'C.I. Uruguay'}, 
    {value: '2', label: 'R.U.T.'}
  ],
};

const cleanableState = {};

const options = (state = {...initialState, ...cleanableState}, action) => {
  switch (action.type) {

    case types.CLEAN:
      return { ...state, ...cleanableState};
      
    case types.SET_OPTIONS_VALUE: {
      const { type, value } = action.payload;
      return {
        ...state,
        [type]: value
      }
    };

    case types.SET_OPTIONS_LIST: {
      const { type, list } = action.payload;
      return {
        ...state,
        [type]: list
      }
    };

    default:
      return state;
  }
};

export default options;
